export default __webpack_public_path__ + "static/media/Accessories.54dd10a4.jpg";